var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "11px",
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2E1AEDFB-EC37-43A5-B9B3-3F6AEAF6923E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Safety-Dashboard-Widgets",
    transform: "translate(-823.000000, -1431.000000)",
    fill: "#70AD47",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(743.000000, 1144.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filter",
    transform: "translate(80.000000, 287.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.54704,0 C6.31140571,0 5.26507429,0.823977143 4.92978286,1.95042286 L0.519542857,1.95042286 C0.107565714,1.95042286 -0.134491429,2.41531429 0.1016,2.75314286 C0.105257143,2.75842286 -0.0209828571,2.58605714 3.06724571,6.79974857 C3.12928,6.89005714 3.16205714,6.99563429 3.16205714,7.10528 L3.16205714,10.05088 C3.16205714,10.3373675 3.22585257,10.600686 3.51293714,10.600686 L5.33499429,10.600686 C5.59636273,10.600686 5.64937143,10.2958057 5.64937143,10.05 L5.64937143,7.10528 C5.64937143,6.99561143 5.68217143,6.89003429 5.74420571,6.79970286 L6.80699429,5.34939429 C8.54731429,5.83942857 10.2769371,4.52603429 10.2769371,2.7256 C10.2769371,1.22269714 9.05232,0 7.54704,0 Z M5.18836571,6.39814857 C5.05499429,6.58027429 4.96365714,6.83472 4.96365714,7.10530286 C4.96365714,8.40235429 4.95085714,9.38421333 4.92525714,10.05088 L3.84777143,10.05 L3.84777143,7.10528 C3.84777143,6.85357714 3.77172571,6.61138286 3.62784,6.4048 C3.62397714,6.39926857 3.74036571,6.55817143 0.865897143,2.63611429 L4.81876571,2.63611429 C4.78546286,3.66130286 5.32450286,4.57808 6.15997714,5.07225143 L5.18836571,6.39814857 Z M7.54704,4.76550857 C6.41986286,4.76550857 5.50283429,3.85042286 5.50283429,2.7256 C5.50283429,1.6008 6.41986286,0.685714286 7.54704,0.685714286 C8.67419429,0.685714286 9.59122286,1.6008 9.59122286,2.7256 C9.59122286,3.85042286 8.67421714,4.76550857 7.54704,4.76550857 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43888,1.83538286 C8.30507429,1.70134857 8.08802286,1.70116571 7.95401143,1.83492571 L7.54704,2.24116571 L7.14006857,1.83492571 C7.00605714,1.70114286 6.78896,1.70130286 6.6552,1.83538286 C6.52141714,1.96937143 6.52162286,2.18646857 6.65563429,2.32025143 L7.06173714,2.72562286 L6.65563429,3.13099429 C6.52162286,3.26477714 6.52141714,3.48187429 6.6552,3.61586286 C6.78852571,3.74944 7.00562286,3.75051429 7.14006857,3.61632 L7.54704,3.21008 L7.95401143,3.61632 C8.08761143,3.74966857 8.30470857,3.75030857 8.43888,3.61586286 C8.57266286,3.48187429 8.57245714,3.26477714 8.43844571,3.13099429 L8.03234286,2.72562286 L8.43844571,2.32025143 C8.57245714,2.18646857 8.57266286,1.96937143 8.43888,1.83538286 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.8fc30c97ce2959a3237a84b465339a4c.svg";
export { ForwardRef as ReactComponent };